module.exports = __webpack_public_path__ + "img/title.46554a87.png";